<template>
  <v-toolbar color="yellow lighten-1 text-center" elevation="0">
    <!-- <v-toolbar-title class=""> -->
    <v-img class="pa-0" src="@/assets/images/img-general/logo.png" width="90" height="40" max-height="100%" align-center
      contain></v-img>
    <!--         <span class="font-weight-bold pa-2 align-self-center">Super Éxito</span>
 -->
    <!--   </v-toolbar-title> -->
    <!--  <v-spacer></v-spacer> -->
    <!-- <v-menu bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-item>
          <v-list-item>
            <v-list-item-title>Menu</v-list-item-title>
          </v-list-item>
        </v-item>
        <v-item>
          <v-list-item>
            <v-list-item-title>Cerrar sesion</v-list-item-title>
          </v-list-item>
        </v-item>
      </v-list>
    </v-menu> -->
  </v-toolbar>
</template>
<script>
export default {
  name: 'AppBar',

  data() {
    return {
      drawer: true,
      mini: true,

    }
  }
}
</script>

